module.exports = __webpack_public_path__ + "img/banner2.f99c7bad.png";